module.exports = __webpack_public_path__ + "static/media/BigBan.d8c0faf9.svg";